// hooks/useAuth.js
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useAuth = (navigate, location) => {
  const dispatch = useDispatch();
  const [isInteractionInProgress, setIsInteractionInProgress] = useState(false); // Flag to track ongoing interactions

  const accessToken = useSelector((state) => state.auth.accessToken);
  const userRole = useSelector((state) => state.auth.role);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!accessToken || !userRole) {
      if (location.pathname !== "/" && isLoggedIn && !isInteractionInProgress) {
        setIsInteractionInProgress(true);
      }
    } else if (location.pathname === "/" && isLoggedIn) {
      navigate("/dashboard", { replace: true });
    }
    setLoading(false);
  }, [
    accessToken,
    userRole,
    isLoggedIn,
    dispatch,
    navigate,
    location.pathname,
    isInteractionInProgress,
  ]);

  return { loading, isLoggedIn, userRole, accessToken };
};
